// State
const state = {}
const langs = ['fr'];
const board = [];
const translations = {};

// Import translations
var files = require.context('@lang/front', true, /^(.*)\.js$/);

files.keys().forEach(file => {
	var name = file.replace(/(\.\/)(.*)(\.js)/gm, `$2`)
	translations[name] = require('@lang/front/'+name+'.js').default
});

// Add app.js translations
translations['app'] = require('@lang/app.js').default

langs.forEach(lang => {

	state[lang] = {};

	Object.keys(translations).map(key => {
		state[lang][key] = translations[key][lang]
	});
	
});


// getters
const getters = {}

// actions
const actions = {}
 
// mutations
const mutations = {
	
	setFr(state, payload) {
		Object.assign(state.fr, payload);
	},

	setEn(state, payload) {
		Object.assign(state.en, payload);
	},

	setTranslation(state, file)
	{
		var translations = require('@lang/front/'+file+'.js').default;

		langs.forEach((lang) => {
			var l = {};
			l[file] = translations[lang];
			Object.assign(state[lang], l);
		});
	}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}